import { render } from "./Movies.vue?vue&type=template&id=675df7b8&scoped=true"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"

import "./Movies.vue?vue&type=style&index=0&id=675df7b8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675df7b8"]])

export default __exports__